// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/fonts/Freehand-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --white: #fff;
  --black: #000;
  --deep-navy: #0a2756;
  --bright-blue: #0080ff;
  --true-teal: #00b5b1;
  --electric-green: #00ffb4;
  --orange-highlight: #ef5b2b;
  --gold-highlight: #ffa800;
  --light-teal: #b2e9e7;
  --mint: #99fdd1;
  --blush: #efb6a3;
  --electric-beige: #ffedca;
  --text-100: #16181a;
  --text-200: #3a3e45;
  --text-300: #6d7581;
  --text-400: #a1a6ae;
  --text-500: #cdd1d7;
  --text-600: #f4f4f4;
  --primary: var(--deep-navy);
  --primary-light: var(--bright-blue);
  --tint: var(--electric-green);
  --tint-light: var(--mint);
  --success: var(--true-teal);
  --success-light: var(--light-teal);
  --error: var(--orange-highlight);
  --error-light: var(--blush);
  --warning: var(--gold-highlight);
  --warning-light: var(--electric-beige);
  --background: #f4f4f4;
}

body {
  margin: 0;
  padding: 0;
  font-family: Poppins, sans-serif;
  background: var(--background);
}

.custom-scroller::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: transparent;
}

.custom-scroller::-webkit-scrollbar {
  width: 6px;
  background-color: transparent;
}

.custom-scroller::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: var(--text-500);
}

.table-scroller::-webkit-scrollbar-track {
  border: 1px solid var(--text-500);
  background-color: transparent;
  border-radius: 8px;
}

.table-scroller::-webkit-scrollbar {
  margin: 0 3px;
  height: 12px;
  width: 12px;
  background-color: transparent;
}

.table-scroller::-webkit-scrollbar-thumb {
  border: 4px solid rgb(0 0 0 / 0%);
  background-clip: padding-box;
  border-radius: 8px;
  background-color: var(--text-500);
}

.ag-floating-bottom::-webkit-scrollbar-track {
  border: 1px solid var(--text-500);
  background-color: transparent;
  border-radius: 8px;
}

.ag-floating-bottom::-webkit-scrollbar {
  margin: 0 3px;
  height: 12px;
  width: 12px;
  background-color: transparent;
}

.ag-floating-bottom::-webkit-scrollbar-thumb {
  border: 4px solid rgb(0 0 0 / 0%);
  background-clip: padding-box;
  border-radius: 8px;
  background-color: var(--text-500);
}

@font-face {
  font-family: mysignaturefont;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.text-sign-box {
  width: -moz-fit-content;
  width: fit-content;
  max-width: 100%;
  margin: auto;
  overflow-x: hidden;
  text-wrap: nowrap;
}

.jMRFUJ {
  /* pdf doc viwer tool menu css */
  z-index: 1111 !important;
}

.ag-input-wrapper::before {
  /* to remove search icon from the date filter from media plan page */
  display: none !important;
}

.checkbox-label .css-ahj2mt-MuiTypography-root {
  width: 85% !important;
}

.css-ndkx32::after {
  height: 23px !important;
}

.date-border.css-bsxjua-MuiFormControl-root-MuiTextField-root .MuiOutlinedInput-root {
  border: none !important;
}

.year-picker.css-fobhp9-MuiFormControl-root-MuiTextField-root .MuiOutlinedInput-root {
  height: 40px !important;
}

.css-1rtg91x-MuiDateCalendar-root {
  background: #fff !important;
  height: 300px !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,kCAAkC;EAClC,gCAAgC;EAChC,2BAA2B;EAC3B,gCAAgC;EAChC,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,4CAAoD;AACtD;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,oEAAoE;EACpE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B","sourcesContent":[":root {\n  --white: #fff;\n  --black: #000;\n  --deep-navy: #0a2756;\n  --bright-blue: #0080ff;\n  --true-teal: #00b5b1;\n  --electric-green: #00ffb4;\n  --orange-highlight: #ef5b2b;\n  --gold-highlight: #ffa800;\n  --light-teal: #b2e9e7;\n  --mint: #99fdd1;\n  --blush: #efb6a3;\n  --electric-beige: #ffedca;\n  --text-100: #16181a;\n  --text-200: #3a3e45;\n  --text-300: #6d7581;\n  --text-400: #a1a6ae;\n  --text-500: #cdd1d7;\n  --text-600: #f4f4f4;\n  --primary: var(--deep-navy);\n  --primary-light: var(--bright-blue);\n  --tint: var(--electric-green);\n  --tint-light: var(--mint);\n  --success: var(--true-teal);\n  --success-light: var(--light-teal);\n  --error: var(--orange-highlight);\n  --error-light: var(--blush);\n  --warning: var(--gold-highlight);\n  --warning-light: var(--electric-beige);\n  --background: #f4f4f4;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: Poppins, sans-serif;\n  background: var(--background);\n}\n\n.custom-scroller::-webkit-scrollbar-track {\n  border-radius: 8px;\n  background-color: transparent;\n}\n\n.custom-scroller::-webkit-scrollbar {\n  width: 6px;\n  background-color: transparent;\n}\n\n.custom-scroller::-webkit-scrollbar-thumb {\n  border-radius: 8px;\n  background-color: var(--text-500);\n}\n\n.table-scroller::-webkit-scrollbar-track {\n  border: 1px solid var(--text-500);\n  background-color: transparent;\n  border-radius: 8px;\n}\n\n.table-scroller::-webkit-scrollbar {\n  margin: 0 3px;\n  height: 12px;\n  width: 12px;\n  background-color: transparent;\n}\n\n.table-scroller::-webkit-scrollbar-thumb {\n  border: 4px solid rgb(0 0 0 / 0%);\n  background-clip: padding-box;\n  border-radius: 8px;\n  background-color: var(--text-500);\n}\n\n.ag-floating-bottom::-webkit-scrollbar-track {\n  border: 1px solid var(--text-500);\n  background-color: transparent;\n  border-radius: 8px;\n}\n\n.ag-floating-bottom::-webkit-scrollbar {\n  margin: 0 3px;\n  height: 12px;\n  width: 12px;\n  background-color: transparent;\n}\n\n.ag-floating-bottom::-webkit-scrollbar-thumb {\n  border: 4px solid rgb(0 0 0 / 0%);\n  background-clip: padding-box;\n  border-radius: 8px;\n  background-color: var(--text-500);\n}\n\n@font-face {\n  font-family: mysignaturefont;\n  src: url('../src/assets/fonts/Freehand-Regular.ttf');\n}\n\n.text-sign-box {\n  width: fit-content;\n  max-width: 100%;\n  margin: auto;\n  overflow-x: hidden;\n  text-wrap: nowrap;\n}\n\n.jMRFUJ {\n  /* pdf doc viwer tool menu css */\n  z-index: 1111 !important;\n}\n\n.ag-input-wrapper::before {\n  /* to remove search icon from the date filter from media plan page */\n  display: none !important;\n}\n\n.checkbox-label .css-ahj2mt-MuiTypography-root {\n  width: 85% !important;\n}\n\n.css-ndkx32::after {\n  height: 23px !important;\n}\n\n.date-border.css-bsxjua-MuiFormControl-root-MuiTextField-root .MuiOutlinedInput-root {\n  border: none !important;\n}\n\n.year-picker.css-fobhp9-MuiFormControl-root-MuiTextField-root .MuiOutlinedInput-root {\n  height: 40px !important;\n}\n\n.css-1rtg91x-MuiDateCalendar-root {\n  background: #fff !important;\n  height: 300px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
